<select class="agu-select" [attr.id]="Id" [attr.aria-label]="Id ? null : AriaLabel" [disabled]="Disabled" (change)="OnChange($event)">
    @for (option of Options; track option.Key) {
        <option [value]="option.Key" [selected]="option.Key === Value">{{ option.Label }}</option>
    }
</select>
